import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Content } from "../../models/content";
import {INgxMyDpOptions, IMyDateModel, IMyDate} from 'ngx-mydatepicker';
@Component({
  selector: 'app-timing',
  templateUrl: './timing.component.html',
  styleUrls: ['./timing.component.scss']
})
export class TimingComponent implements OnInit {

  @Input()
  content: Content;

  @Output() contentChangeEvent = new EventEmitter<void>();

  @Input()
  primaryColor: string;
  @Input()
  secondaryColor: string;

  startDate: Date;
  endDate: Date;

  constructor() { }

  ngOnInit() {
    this.startDate = new Date();
    if(this.content.startDate){
      this.startDate = new Date(this.content.startDate);
    }
    this.endDate = new Date(this.startDate.getFullYear(),this.startDate.getMonth()+1,this.startDate.getDate());
    if(this.content.endDate){
      this.endDate = new Date(this.content.endDate);
    }
    this.content.startDate = this.startDate.toLocaleDateString("en-US").replace(/\u200E/g, '');
    this.content.endDate = this.endDate.toLocaleDateString("en-US").replace(/\u200E/g, '');
    this.contentChangeEvent.emit();
  }

  getDateOptions(isStart: boolean): INgxMyDpOptions{
    let minDate = new Date();
    if (!isStart && this.startDate) minDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
    else minDate.setDate(minDate.getDate()-1);
    let minMyDate: IMyDate = {year: minDate.getFullYear(), month: minDate.getMonth()+1, day: minDate.getDate()};
    let maxMyDate: IMyDate = {year: minDate.getFullYear()+1, month: minDate.getMonth()+1, day: minDate.getDate()+1};
    let options: INgxMyDpOptions = {
      dateFormat: 'mm/dd/yyyy',
      alignSelectorRight: true,
      firstDayOfWeek: 'su',
      sunHighlight: false,
      minYear: 2018,
      disableUntil: minMyDate,
      disableSince: maxMyDate
    };
    return options;
  }

  onDateChanged(event: IMyDateModel, isStart: boolean){
    if(isStart){
      this.startDate = event.jsdate;
      this.content.startDate = this.startDate.toLocaleDateString("en-US").replace(/\u200E/g, '');
    } else{
      this.endDate = event.jsdate;
      this.content.endDate = this.endDate.toLocaleDateString("en-US").replace(/\u200E/g, '');
    }
    if(this.endDate < this.startDate){
      this.endDate = new Date(this.startDate.getFullYear(),this.startDate.getMonth(),this.startDate.getDate()+1);
      this.content.endDate = this.endDate.toLocaleDateString("en-US").replace(/\u200E/g, '');
    }
    this.contentChangeEvent.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timing/timing.component.ts